import React from 'react';
import { useTranslation } from 'react-i18next';
import './AppPromo.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faStar } from '@fortawesome/free-solid-svg-icons';

const AppPromo: React.FC = () => {
  const { t } = useTranslation();

  return (
    <section className="app-promo">
      <div className="container">
        <div className="app-promo-content">
          <div className="app-promo-text">
            <h2>{t('appPromo.header')}</h2>
            <p className="app-promo-description">
              {t('appPromo.description')}
            </p>
            
            <div className="app-rating">
              <div className="rating-score">4,7</div>
              <div className="stars">
                <FontAwesomeIcon icon={faStar} />
                <FontAwesomeIcon icon={faStar} />
                <FontAwesomeIcon icon={faStar} />
                <FontAwesomeIcon icon={faStar} />
                <FontAwesomeIcon icon={faStar} className="star-half" />
              </div>
            </div>

            <div className="app-stores">
              <a 
                href="https://apps.apple.com/us/app/yata-m%C3%A9dical/id6615080510" 
                target="_blank" 
                rel="noopener noreferrer"
                className="store-button"
              >
                <img 
                  src="/images/googlePlay.png" 
                  alt={t('appPromo.alt_ios')} 
                />
              </a>
              <a 
                href="https://play.google.com/store/apps/details?id=com.yatamedical.YataPatient" 
                target="_blank" 
                rel="noopener noreferrer"
                className="store-button"
              >
                <img 
                  src="/images/playStore.png" 
                  alt={t('appPromo.alt_android')} 
                />
              </a>
            </div>
          </div>
          
          <div className="app-promo-image">
            <img 
              src="/images/Sans-tit.png" 
              alt={t('appPromo.phone_alt')} 
              className="phone-mockup"
            />
          </div>
        </div>
      </div>
    </section>
  );
};

export default AppPromo;
